module.exports = require("./tr-TR.js");